import React, { useEffect, useState } from "react";
import dangerIconRed from "../../assets/images/icons/dangerIconRed.svg";
const MemoArea = ({ value, onChange, error = "", helperText = "", label = "", id, name, mandatory, ...props }) => {
  const [touched, setTouched] = useState(false);
  const [errorText, setErrorText] = useState(error);

  useEffect(() => {
    setErrorText(error);
  }, [error]);
  const handleTextAreaBlur = () => {
    setTouched(true);
    if (!value) {
      setErrorText("Memo cannot be empty");
    } else {
      setErrorText("");
    }
  };

  return (
    <div className="flex flex-col mb-4" role="form">
      {label && (
        <label htmlFor={id} className="text-sm font-medium text-gray-700 mb-1" aria-label={label}>
          {label}
        </label>
      )}
      <textarea
        type="text"
        value={value}
        onChange={onChange}
        name={name}
        placeholder="Enter memo here..."
        className={`px-3 py-2 border rounded-md text-sm h-[120px] w-full ${
          mandatory && ((touched && !value) || errorText) && !value
            ? "border-red-500 focus:ring-red-500 focus:border-red-500"
            : "border-gray-300 focus:ring-blue-500 focus:border-blue-500"
        } resize-none`}
        id={id}
        aria-invalid={errorText ? "true" : "false"}
        aria-describedby={helperText && touched && !value ? `${id}-helper` : undefined}
        onBlur={handleTextAreaBlur}
        {...props}
      />
      {Boolean(mandatory) && helperText && ((touched && !value) || errorText) && !value && (
        <span
          id={`${id}-helper`}
          className="flex gap-1 items-center text-xs text-[#BF2315] text-[10px] mt-1"
          role="alert"
          aria-live="assertive"
        >
          <img src={dangerIconRed} className="h-[10px] w-[10px]" alt="Error icon" />
          {helperText}
        </span>
      )}
    </div>
  );
};

export default MemoArea;
